import { Commit } from 'vuex';
import { MenuState } from '.';

export interface LayoutActionType {
    commit: Commit;
    state: MenuState;
    getters: any;
}

export enum LayoutAction {
    GET_SITES = 'GET_SITES',
    GET_STATUT_BIM = 'GET_STATUT_BIM',
}
